module.exports = __webpack_public_path__ + "img/ciazForm.3cb2b5c5.svg";